
const colorValues = {
  'darkGreen': 'rgba(0, 100, 112, 0.8)', // dark green,
  'tan': 'rgba(94, 117, 65, 0.8)', // really more of a dark green
  'yellow': 'rgba(229, 197, 32, 0.8)', // yellow
  'orange': 'rgba(239, 139, 52, 0.8)', // orange
  'pink': 'rgba(210, 159, 171, 0.8)', // pink
  'darkBlue': 'rgba(32, 48, 97, 0.8)', // darkblue
  'blue': 'rgba(0, 139, 205, 0.8)',
  'teal': 'rgba(51, 151, 149, 0.8)',
  'purple': 'rgba(96,63,101,0.8)',
  'gray': 'rgba(178, 178, 176, 0.8)'
}

const phylumColors = {
  p__Actinobacteria: colorValues.teal,
  p__Bacteroidetes: colorValues.purple,
  p__Cyanobacteria: colorValues.teal,
  p__Desulfobacterota: colorValues.darkGreen,
  p__Epsilonbacterota: colorValues.teal,
  p__Euryarchaeota: colorValues.teal,
  p__Firmicutes: colorValues.yellow,
  p__Firmicutes_A: colorValues.yellow,
  p__Firmicutes_B: colorValues.yellow,
  p__Firmicutes_C: colorValues.yellow,
  p__Fusobacteria: colorValues.darkBlue,
  p__Proteobacteria: colorValues.pink,
  p__Synergistetes: colorValues.teal,
  p__Unmapped: colorValues.teal,
  p__Verrucomicrobia: colorValues.darkGreen
}

const phylumColorsClass = {
  p__Actinobacteria: 'teal',
  p__Bacteroidetes: 'purple',
  p__Cyanobacteria: 'teal',
  p__Desulfobacterota: 'darkGreen',
  p__Epsilonbacterota: 'teal',
  p__Euryarchaeota: 'teal',
  p__Firmicutes: 'yellow',
  p__Firmicutes_A: 'yellow',
  p__Firmicutes_B: 'yellow',
  p__Firmicutes_C: 'yellow',
  p__Fusobacteria: 'darkBlue',
  p__Proteobacteria: 'pink',
  p__Synergistetes: 'teal',
  p__Unmapped: 'teal',
  p__Verrucomicrobia: 'darkGreen'
}

export default {

  methods: {
    speciesColor: function (key) {
      return phylumColors[key] || 'rgba(1,1,1,0.6)'
    },
    taxonomyPhylum: function (taxonomies) {
      return taxonomies.filter(taxonomy => taxonomy.startsWith('p__'))
    },
    taxonomyGenus: function (taxonomies) {
      return taxonomies.filter(taxonomy => taxonomy.startsWith('g__'))
    },
    taxonomyFamily: function (taxonomies) {
      return taxonomies.filter(taxonomy => taxonomy.startsWith('f__'))
    },
    colorPhylumFromTax: function (string) {
      const taxonomies = this.taxonomyPhylum(string.split('; '))
      return this.colorPhylum(taxonomies[0])
    },
    colorClassPhylumFromTax: function (string) {
      const taxonomies = this.taxonomyPhylum(string.split('; '))
      return this.colorPhylum(taxonomies[0], true)
    },
    phylumNameFromTax: function (string) {
      const taxonomies = this.taxonomyPhylum(string.split('; '))
      return taxonomies[0]
    },
    colorPhylum: function (phylum, onlyClass = false) {
      if (onlyClass) {
        return phylumColorsClass[phylum] || 'gray'
      }
      return phylumColors[phylum] || 'rgba(0,0,0,0.2)'
    },
    mapApiResponseToArray: function (response) {
      const collection = []
      for (var element in response) {
        const obj = Number(response[element]) ? Number(response[element]) : response[element]
        obj.key = element
        obj.phylum = ''
        if ('abundance' in obj === false) {
          obj.abundance = 0
        }
        collection.push(obj)
      }
      return collection
    },
    // @todo Microba Dave wrote a variation in R. Check that this is correct
    getXPosition: function (allRatios, minX, maxX, ratio) {
      const minRatio = Math.min(...allRatios)
      const maxRatio = Math.max(...allRatios)
      const rangeLogRatios = maxRatio - minRatio
      const rangeCoordinates = maxX - minX

      const result = (((ratio - minRatio) / rangeLogRatios) * rangeCoordinates) + minX
      return result
    },
    getRatio: function (average, abundance) {
      const pseudoCount = 0.0001
      return Math.log((abundance + pseudoCount) / (average + pseudoCount))
    },
    getRatioSimple: function (abundance) {
      const pseudoCount = 0.0001
      return Math.log((abundance + pseudoCount))
    },
    cleanseComparisonData: function (data) {
      const collection = []
      for (var item in data) {
        const row = data[item]
        if (row.abundance !== 0) {
          collection.push(row)
        }
      }
      return collection
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/@microbadevs/report/src/mixins/chartColor.js
// module id = 0yfA
// module chunks = 0